/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function FilterIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M22.9.64a.94.94,0,0,1-.23,1.15l-8,8.09V22.05A1,1,0,0,1,14,23a1.29,1.29,0,0,1-.41.08,1,1,0,0,1-.74-.31l-4.17-4.2a1,1,0,0,1-.31-.74v-8l-8-8.09A.94.94,0,0,1,.1.64a1,1,0,0,1,1-.64H21.94A1,1,0,0,1,22.9.64Z" />
    </SvgIcon>
  );
}
